module.exports = __webpack_public_path__ + "images/7590426945e2bd9dc09f81ae196ca32e.jpg";